<template>
  <v-app class="pt-15">
    <customize-header homeRouter="/marketingDiversion/home"
                      homeTitle="运营导流"
                      :links="links"></customize-header>
    <router-view></router-view>
    <customize-suspendBtn></customize-suspendBtn>
    <customize-footer></customize-footer>
  </v-app>
</template>

<script>
export default {
  name: 'MarketingDiversionIndex',
  data: () => ({
    links: [
      {
        title: "首页",
        router: "/marketingDiversion/home",
        children: []
      },
      {
        title: "服务内容",
        router: "/marketingDiversion/serviceContent",
        children: []
      },
      {
        title: "大数据",
        router: "/marketingDiversion/bigData",
        children: []
      }
    ],
  }),
  mounted() {
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
</style>